export const MATCH_VARIANT = {
    STANDARD: "standard",
};
export const GAME_OVERRIDE = Object.freeze({
    PVAI: 64,
    PVP: 65,
    SCENARIO: 66,
    TOURNAMENT: 68,
});
export const CHESS_EMPTY_BOARD_FEN = "8/8/8/8/8/8/8/8 w - - 0 1";
export const CHESS_START_POSITION = "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1";
export const FEN_PIECES = [
    "K",
    "Q",
    "R",
    "B",
    "N",
    "P",
    "k",
    "q",
    "r",
    "b",
    "n",
    "p",
];
export const CHESS_SIDE = Object.freeze({
    BLACK: "black",
    WHITE: "white",
});
export const CHESS_PIECES = Object.freeze({
    K: "KING",
    Q: "QUEEN",
    R: "ROOK",
    B: "BISHOP",
    N: "KNIGHT",
    P: "PAWN",
});
// a function that take CHESS_PIECES and CHESS_SIDE and return their fen equivalent
export const getFenPiece = (piece, side) => {
    if (!piece || !side)
        return "";
    const fenPiece = piece.toUpperCase() === CHESS_PIECES.N ? "N" : piece[0];
    if (!FEN_PIECES.includes(fenPiece))
        return "";
    if (side === CHESS_SIDE.WHITE) {
        return fenPiece.toUpperCase();
    }
    if (side === CHESS_SIDE.BLACK) {
        return fenPiece.toLowerCase();
    }
    return "";
};
export const GAME_RESULT = Object.freeze({
    CHECKMATE: "checkmate",
    STALEMATE: "stalemate",
    THREEFOLD_REPETITION: "threefold_repetition",
    INSUFFICIENT_MATERIAL: "insufficient_material",
    DRAW: "draw",
    DRAW_BY_AGREEMENT: "draw by agreement",
    GAME_OVER: "game_over",
    ABORT: "abort", // abort when leewayDuration runs out in non tournament game
    WHITE_ABORT: "white_abort", // abort by white when leewayDuration remains
    BLACK_ABORT: "black_abort", // abort by black when leewayDuration remains
    BARE_KING: "bare king",
    TIMEOUT: "timeout",
    FORFEIT: "forfeit",
    RESIGN: "resign",
    END: "end",
});
export const LEEWAY_DURATION = 30; // 30s for first move
export const TIMEOUT_LEEWAY_SECONDS = 2; // 2s to wait before handle timeout
export const MATCH_STATUS = Object.freeze({
    CREATED: "created",
    STARTED: "started",
    ABORTED: "aborted",
    LIVE: "live",
    FINISHED: "finished",
});
export const SIMUL_STATUS = Object.freeze({
    CREATED: "created",
    STARTED: "started",
    FINISHED: "finished",
    CLOSED: "closed",
});
export const TOURNAMENT_GAME_RESULT = Object.freeze({
    LOSS: 0,
    WIN: 1,
    DRAW: 2,
    FORFEITW: 3,
    FORFEITL: 4,
    FORFEITD: 5,
    UNFINISHED: 6,
    FULLBYE: 7,
    ZEROBYE: 8,
    HALFBYE: 9,
    PAIRINGBYE: 10,
    DISQUALIFIED: 11,
});
export const TOURNAMENT_FIDE_GAME_RESULT = Object.freeze({
    0: "0",
    1: "1",
    2: "=",
    3: "+",
    4: "-",
    5: "=",
    6: "",
    7: "F",
    8: "Z",
    9: "H",
    10: "U",
    11: "Z",
});
export const TOURNAMENT_GAME_RESULT_TEXT = Object.freeze([
    "LOSS",
    "WIN",
    "DRAW",
    "Forfeit Win",
    "Forfeit Loss",
    "Forfeit Draw",
    "Unfinished",
    "FULLBYE",
    "ZEROBYE",
    "HALFBYE",
    "PAIRINGBYE",
    "DISQUALIFIED",
]);
export const TOURNAMENT_GAME_RESULT_SCORE = Object.freeze([
    0,
    1,
    0.5,
    1,
    0,
    0.5,
    null,
    1,
    0,
    0.5,
    1,
    0,
]);
export const TOURNAMENT_DEFAULT_SCORING = {
    bestOf: 1,
    win: 1,
    draw: 0.5,
    loss: 0,
    bye: 1,
    tiebreaks: [
        "median buchholz",
        "solkoff",
        "cumulative",
    ],
};
export const AI_NAMES = {
    CHESSIE: "Chessie",
    PROFESSOR_NINJA: "Professor Ninja",
    ALIEN_BRAIN: "Alien Brain",
};
export const CHESS_ENGINES = ["Stockfish", "Lozza", "P4wn"];
export const CHESS_ENGINE = {
    STOCKFISH: "Stockfish",
    LOZZA: "Lozza",
    P4WN: "P4wn",
};
